
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skills-hub/[categoryId]",
      function () {
        return require("private-next-pages/skills-hub/[categoryId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skills-hub/[categoryId]"])
      });
    }
  